// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.th-wrap {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  min-height: 28px;
}
.th-spark {
  width: 20px;
  height: 20px;
  fill: var(--v2-primary, #1f2937);
  flex: none;
  animation:
    th-spin 2.4s linear infinite,
    th-pulse 1.2s ease-in-out infinite;
  transform-origin: 50% 50%;
}
.th-text {
  font-size: 14px;
  font-weight: 500;
  background: linear-gradient(
    90deg,
    #9ca3af 0%,
    #9ca3af 35%,
    #1f2937 50%,
    #9ca3af 65%,
    #9ca3af 100%
  );
  background-size: 250% 100%;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  animation:
    th-shimmer 1.8s linear infinite,
    th-fade 0.3s ease-out;
}
@keyframes th-spin {
  to {
    rotate: 360deg;
  }
}
@keyframes th-pulse {
  0%,
  100% {
    scale: 0.85;
    opacity: 0.75;
  }
  50% {
    scale: 1.05;
    opacity: 1;
  }
}
@keyframes th-shimmer {
  from {
    background-position: 100% 0;
  }
  to {
    background-position: -150% 0;
  }
}
@keyframes th-fade {
  from {
    opacity: 0;
    transform: translateY(3px);
  }
}
@media (prefers-reduced-motion: reduce) {
  .th-spark,
  .th-text {
    animation: none;
  }
  .th-text {
    color: #6b7280;
    background: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/test-chat/ui/thinking.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,UAAU;EACV;;sCAEoC;EACpC,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB;;;;;;;GAOC;EACD,0BAA0B;EAC1B,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;EAClB;;yBAEuB;AACzB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE;;IAEE,WAAW;IACX,aAAa;EACf;EACA;IACE,WAAW;IACX,UAAU;EACZ;AACF;AACA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;AACA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;AACF;AACA;EACE;;IAEE,eAAe;EACjB;EACA;IACE,cAAc;IACd,gBAAgB;EAClB;AACF","sourcesContent":[".th-wrap {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  min-height: 28px;\n}\n.th-spark {\n  width: 20px;\n  height: 20px;\n  fill: var(--v2-primary, #1f2937);\n  flex: none;\n  animation:\n    th-spin 2.4s linear infinite,\n    th-pulse 1.2s ease-in-out infinite;\n  transform-origin: 50% 50%;\n}\n.th-text {\n  font-size: 14px;\n  font-weight: 500;\n  background: linear-gradient(\n    90deg,\n    #9ca3af 0%,\n    #9ca3af 35%,\n    #1f2937 50%,\n    #9ca3af 65%,\n    #9ca3af 100%\n  );\n  background-size: 250% 100%;\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n  animation:\n    th-shimmer 1.8s linear infinite,\n    th-fade 0.3s ease-out;\n}\n@keyframes th-spin {\n  to {\n    rotate: 360deg;\n  }\n}\n@keyframes th-pulse {\n  0%,\n  100% {\n    scale: 0.85;\n    opacity: 0.75;\n  }\n  50% {\n    scale: 1.05;\n    opacity: 1;\n  }\n}\n@keyframes th-shimmer {\n  from {\n    background-position: 100% 0;\n  }\n  to {\n    background-position: -150% 0;\n  }\n}\n@keyframes th-fade {\n  from {\n    opacity: 0;\n    transform: translateY(3px);\n  }\n}\n@media (prefers-reduced-motion: reduce) {\n  .th-spark,\n  .th-text {\n    animation: none;\n  }\n  .th-text {\n    color: #6b7280;\n    background: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
